export default "__VITE_ASSET__BLwc6Htt__"